import axios from '@/core/axios';

import { CollectionList } from '../collections/collections.types';
import { SaveBase64Options } from '../file/file.types';
import { Invoice, InvoiceListOptions } from './invoices.types';

export class InvoicesService {
  update;

  list(opts: InvoiceListOptions = {}): Promise<CollectionList<'invoices'>> {
    const { filters, pagination } = opts;

    return axios
      .get<CollectionList<'invoices'>>(`/invoices`, { params: { ...filters, ...pagination } })
      .then(resp => resp?.data);
  }

  downloadInvoice(invoiceId: number): Promise<SaveBase64Options> {
    return axios.get<SaveBase64Options>(`/invoices/download/${invoiceId}`).then(resp => {
      const { base_64, filename, type } = resp?.data || {};
      if (!base_64 || !filename || !type)
        throw new Error(`Pièce comptable non disponible pour la facture ${invoiceId}`);
      return { base_64, filename, type };
    });
  }

  listByOrder(orderId: number): Promise<Invoice[]> {
    return axios.get<Invoice[]>(`/invoices/list/${orderId}`).then(resp => {
      const invoices = resp?.data || [];
      invoices.sort((b, a) => new Date(a.created_at).getTime() - new Date(b.created_at).getTime());
      return invoices;
    });
  }

  generateCreditNoteForInvoice(invoiceId: number): Promise<SaveBase64Options> {
    return axios.post<SaveBase64Options>(`/invoices/${invoiceId}/generate-credit-note`).then(resp => {
      const { base_64, filename, type } = resp?.data || {};
      if (!base_64 || !filename || !type) throw new Error(`Avoir non généré pour la facture ${invoiceId}`);
      return { base_64, filename, type };
    });
  }

  majInvoices() {
    try {
      axios.post(`/invoices/maj_invoices`).then(() => alert('MAJ des factures effectuée avec succès !'));
    } catch (error) {
      alert('Erreur lors de la mise à jour des factures');
    }
  }
}
export const invoicesService = new InvoicesService();
